import { render } from "./UsersDataChart.vue?vue&type=template&id=5538d8f2&scoped=true&ts=true"
import script from "./UsersDataChart.vue?vue&type=script&lang=ts"
export * from "./UsersDataChart.vue?vue&type=script&lang=ts"

import "./UsersDataChart.vue?vue&type=style&index=0&id=5538d8f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5538d8f2"]])

export default __exports__